import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentMutationToolName } from './useTrackAgentWorkspaceModified.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export {
  WORKSPACE_AGENT_MUTATION_TOOL_NAMES,
  type WorkspaceAgentMutationToolName,
} from './useTrackAgentWorkspaceModified.meta';

export type WorkspaceAgentMutationToolParams = {
  asset_count?: number;
  custom_field_id?: string;
  destination_type?: 'board';
  failed_count?: number;
  output_status?: string;
  renamed_count?: number;
  requested_count?: number;
  saved_count?: number;
  tags_added_count?: number;
  tags_removed_count?: number;
};

export type UseTrackAgentWorkspaceModifiedParams = {
  mutation_occurred: boolean;
  success: boolean;
  tool_name: WorkspaceAgentMutationToolName;
  tool_params: WorkspaceAgentMutationToolParams;
};

export const useTrackAgentWorkspaceModified = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentWorkspaceModified = useCallback(
    (params: UseTrackAgentWorkspaceModifiedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentWorkspaceModified };
};
